import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GroupDetailsForm {
  fieldName: string;
}

export interface GroupDetails {
  _id: string;
  studio: string;
  fieldName: string;
  fieldType: string;
}

export const createGroupAPI = async (groupDetails: GroupDetailsForm) => {
  const resp = await baseAPI.post<GroupDetails>(
    '/custom-form/group',
    groupDetails,
  );
  return resp.data;
};

export const useCreateGroupMutation = () => {
  return useMutation({
    mutationFn: async (groupDetails: GroupDetailsForm) => {
      const response = await createGroupAPI(groupDetails);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.GROUPS],
      });
    },
  });
};
